import { Link } from "react-router-dom";
import { categoryList, getCategoryPath, sortByHeat } from "@/utils/content";

export default function SiteFooter() {
  const hotList = sortByHeat().slice(0, 4);

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                热搜吃瓜
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              把热门事件的前因、经过与结果按时间顺序汇总到一处，帮你在一个页面里看清来龙去脉。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
              <Link to="/events" className="transition-colors hover:text-accent-300">
                瓜田总览
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {hotList.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/event/${item.slug}`}
                    className="text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
              主题分类
            </h4>
            <ul className="space-y-2.5 text-sm">
              {categoryList.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={getCategoryPath(category.slug)}
                    className="text-background-200 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
              关于与联系
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background-200 transition-colors hover:text-accent-300"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#method"
                  className="text-background-200 transition-colors hover:text-accent-300"
                >
                  复盘方法
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-background-200 transition-colors hover:text-accent-300"
                >
                  联系与反馈
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contact@hot-melon-watch.example.com"
                  rel="nofollow"
                  className="text-background-200 transition-colors hover:text-accent-300"
                >
                  contact@hot-melon-watch.example.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 热搜吃瓜 · 内容均基于公开信息整理，仅供阅读参考</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-300">
              内容原则
            </Link>
            <Link to="/events" className="transition-colors hover:text-accent-300">
              全部事件
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}